<dgx-mentoring-mentees
  *ngIf="mentees.length"
  [mentees]="mentees"
  [isLoading]="isLoading"
  [isSorting]="isSorting"
  (menteesUpdate)="onMenteesUpdate($event)"
></dgx-mentoring-mentees>
<dgx-mentoring-mentors
  *ngIf="mentors.length"
  [mentors]="mentors"
  [isLoading]="isLoading"
  [isSorting]="isSorting"
  (mentorsUpdate)="onMentorsUpdate($event)"
></dgx-mentoring-mentors>
<div
  class="center-text guts-p-t-6 guts-p-b-1-half"
  *ngIf="!mentees.length && !mentors.length && !isLoading"
>
  <img
    [alt]="i18n.Core_Empty_Image_Alt"
    [src]="noItemsImage"
    class="image-layout--empty"
  />
  <p class="color-ebony-a45-hue font-semibold guts-p-t-2">
    {{ i18n.Opportunities_NoMentorship }}
  </p>
</div>
<div class="grd__col-12 crap">
  <dgx-footer-glasses [hidden]="isLoading"></dgx-footer-glasses>
</div>
